<template>
  <q-card style="min-width: 350px">
    <q-card-section>
      <div class="text-h6">
        {{ isEditing ? 'Guncelle' : 'Yeni Abonelik Paketi' }}
      </div>
    </q-card-section>

    <q-card-section class="q-pt-none">
      <q-form class="q-gutter-md">
        <!-- Subscription Plan Title -->
        <q-input
          v-model="title"
          filled
          label="Baslik"
          lazy-rules
          :rules="[(val) => (val && val.length > 0) || 'Bos olamaz']"
        />

        <!-- Subscription Plan Price -->
        <q-input
          v-model.number="price"
          filled
          type="number"
          label="Fiyat (TL)"
          lazy-rules
          :rules="[(val) => (val && parseInt(val) > 0) || 'Bir fiyat giriniz']"
        />

        <!-- Subscription Plan Regional Loss -->
        <q-input
          v-model.number="regionalLoss"
          filled
          type="number"
          label="Bolgesel Zayiflama Sayisi"
        />

        <!-- Subscription Plan Regime Session -->
        <q-input
          v-model.number="regimeSession"
          filled
          type="number"
          label="Diyet Seans Sayisi"
        />
      </q-form>
    </q-card-section>

    <q-card-actions align="right" class="text-primary">
      <q-btn v-close-popup flat label="Vazgec" color="red" />
      <q-btn
        v-close-popup
        flat
        :label="isEditing ? 'Guncelle' : 'Ekle'"
        color="secondary"
        @click="onSubmit"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { ref, toRefs, inject } from 'vue'
import axios from 'axios'
import * as eventNames from '../../utils/events'
import * as notify from '../../utils/notification'
export default {
  props: {
    isEditing: Boolean,
    subscription: Object,
  },
  setup(props) {
    const $q = useQuasar()
    const emitter = inject('emitter')
    let { isEditing, subscription } = toRefs(props)

    // subscription form inputs
    const title = ref(null)
    const price = ref(0)
    const regionalLoss = ref(0)
    const regimeSession = ref(0)

    if (isEditing.value) {
      title.value = subscription.value.title
      price.value = subscription.value.price
      regionalLoss.value = subscription.value.limits['REGIONAL_LOSS']
      regimeSession.value = subscription.value.limits['REGIME_SESSION']
    }

    return {
      title,
      price,
      regionalLoss,
      regimeSession,

      onSubmit() {
        if (isEditing.value) {
          axios
            .put(`/subscriptions/${subscription.value.id}`, {
              title: title.value,
              price: price.value,
              limits: {
                REGIONAL_LOSS: regionalLoss.value,
                REGIME_SESSION: regimeSession.value,
              },
            })
            .then(() => {
              $q.notify(notify.success('Paket guncellendi.'))
              emitter.emit(eventNames.REFRESH_SUBSCRIPTIONS)
            })
            .catch(() => {
              $q.notify(notify.warning('Paket guncellenemedi.'))
            })
        } else {
          axios
            .post('/subscriptions/', {
              title: title.value,
              price: price.value,
              limits: {
                REGIONAL_LOSS: regionalLoss.value,
                REGIME_SESSION: regimeSession.value,
              },
            })
            .then(() => {
              $q.notify(notify.success('Paket eklendi.'))
              emitter.emit(eventNames.REFRESH_SUBSCRIPTIONS)
            })
            .catch(() => {
              $q.notify(notify.warning('Paket eklenemedi.'))
            })
        }
      },
    }
  },
}
</script>
